import { ComponentProps, useState } from 'react';

import { ClickableFilterTag } from './ClickableFilterTag';
import { FilterTag } from './FilterTag';
import { useFormatMessage } from '../../hooks/useFormatMessage';

type Props = {
  label: string;
  removePopoverContent?: string;
  items: string[];
  popoverContent?: React.ReactNode;
  onRemoveClick: () => void;
  size?: ComponentProps<typeof FilterTag>['size'];
};

export const ArrayFilterTag: React.FC<Props> = ({
  label,
  removePopoverContent,
  items,
  popoverContent,
  onRemoveClick,
  size,
}) => {
  const [open, setOpen] = useState(false);
  const formatMessage = useFormatMessage();

  if (items.length === 0 && !open) return null;

  const formattedItems = () => (
    <>
      {items.length === 0 && formatMessage('components.array_filter_tag.none_selected')}
      {items.length === 1 && items[0]}
      {items.length > 1 && (
        <span title={items.join(', ')}>
          {formatMessage('components.array_filter_tag.text', {
            item: items[0],
            count: items.length - 1,
          })}
        </span>
      )}
    </>
  );

  if (popoverContent) {
    return (
      <ClickableFilterTag
        label={label}
        removePopoverContent={removePopoverContent}
        popoverContent={popoverContent}
        onRemoveClick={(event) => {
          // We stop propagation to avoid opening the popover when clearing filters
          event.stopPropagation();
          onRemoveClick();
        }}
        size={size}
        open={open}
        onOpenChange={setOpen}
      >
        {formattedItems()}
      </ClickableFilterTag>
    );
  }

  return (
    <FilterTag
      label={label}
      removePopoverContent={removePopoverContent}
      onRemoveClick={onRemoveClick}
      size={size}
    >
      {formattedItems()}
    </FilterTag>
  );
};
